import React from "react";
import { PlainButton } from "@jugl-web/ui-components";
import { PinButton } from "../PinButton/PinButton";
import { ReactComponent as ReorderIcon } from "./assets/reorder.svg";

export const SidebarToolItem: React.FC<{
  title: string;
  isPinned: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isAtLimit?: boolean;
  isDraggable?: boolean;
  onPinClick: (e: React.SyntheticEvent) => void;
}> = ({ title, icon: Icon, isPinned, isDraggable, isAtLimit, onPinClick }) => (
  <div className="bg-grey-100 font-secondary text-dark relative flex h-[41px] items-center gap-2 rounded-lg pl-2 pr-4 text-sm">
    {isDraggable && (
      <PlainButton onClick={(event) => event.stopPropagation()}>
        <ReorderIcon />
      </PlainButton>
    )}
    {Icon && <Icon />}
    {title}
    <PinButton
      onClick={onPinClick}
      isPinned={isPinned}
      isAtLimit={isAtLimit}
      className="absolute right-2"
    />
  </div>
);
